import { basenameFind, getMetaFromJcamp, getTargetProperty, } from "../common.js";
const xrd = {
    jpath: ['spectra', 'xrd'],
    find: basenameFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default xrd;
//# sourceMappingURL=xrd.js.map